export default {
    name: 'Utils',
    /**
     * Функция предназначена для сравнения структуры двух объектов.
     * Работает только с объектами без функций (Plain Object)
     *
     * @param {Object} a
     * @param {Object} b
     * @returns {boolean}
     */
    objectStructEqual(a, b) {
        if (a === b) {
            return true;
        }

        if (a == null || typeof a !== 'object' ||
            b == null || typeof b !== 'object') {
            return false;
        }

        let propsA = [], propsB = [];
        for (let property in a) {
            propsA.push(property);
        }
        for (let property in b) {
            propsB.push(property);
        }
        propsA.forEach((pa) => {
            if (typeof a[pa] === 'object') if (!this.objectStructEqual(a[pa], b[pa])) return false;
            if (!propsB.includes(pa)) return false;
        });
        return true;
    },

    /**
     * Проверяет значение на пустоту или существование (аналог функции PHP)
     * @param {type} value
     * @returns {Boolean}
     */
    empty(value){
        if (typeof value === 'undefined') return true;
        if (value === undefined) return true;
        if (value === null) return true;
        if (value === '') return true;
        if (value === 0) return true;
        return value.length !== undefined && value.length === 0
    },

    /**
     * Проверяет значение на null и undefined (аналог функции PHP)
     * @param {type} value
     * @returns {Boolean}
     */
    isNull(value){
        return (typeof value === 'undefined') || (value === undefined) || (value === null)
    },

    authHeader(token) {
        if (token) {
            return { Authorization: `Bearer   ${token}`};
        } else {
            return {};
        }
    },

    mapSpr(spr = [], idName = '', tempFunc = () => {return ''}, filter = () => {return {}}) {
        if (spr.length === 0) return spr;
        return spr.map(el => {
            return {value: el[idName], text: tempFunc(el), filter: filter(el) }
        })
    },

    mapDialogSpr(spr = {data: [], loading: false, error: null}) {
        if (Object.prototype.toString.call(spr) === '[object Array]'){
            return {data: spr ?? [], loading: false, error: null}
        }else{
            const [data, loading, error] = Object.values(spr);
            if (data !== undefined && loading !== undefined && error !== undefined)
                return spr;
            else
                return {data: data ?? [], loading: loading ?? false, error: error ?? null}
        }
    },

    clearValue(el) {
        if (el.typeVar === 'string')
            el[el.variable] = ''
        else if (el.typeVar === 'integer')
            el[el.variable] = '0'
        else if (el.typeVar === 'float')
            el[el.variable] = '0.0'
        else if (el.typeVar === 'date') {
            if (el.typeDate === 'month')
                el[el.variable] = null
            else
                el[el.variable] = null
        } else {
            el[el.variable] = null
        }
    },

    async openDialog(vueThis, type = 'action', row = null) {
        if (type === 'edit') {
            vueThis.dataForDialog = row
            await vueThis.$refs.dialog.openDialog()
        } else {
            // eslint-disable-next-line no-unused-vars
            const res = vueThis.$refs.dialog.openDialog()
        }
    },
}